@let alertType = type();

<div
    role="alert"
    class="last:[&>div>p]:mb-0 flex flex-col gap-2"
    [class]="classList()"
    [ngClass]="{
        'bg-[#faf3f3] border-redesign-danger-600 dark:border-redesign-danger-500 dark:bg-redesign-danger-500/5': alertType === 'danger',
        'bg-[#fffbf0] border-redesign-warning-500 dark:bg-redesign-warning-500/5': alertType === 'warning',
        'bg-[#ebf4fa] border-redesign-info-500 dark:border-white dark:bg-white/5': alertType === 'info',
        'bg-[#f5f9f8] border-redesign-success-600 dark:border-redesign-success-400 dark:bg-redesign-success-400/5': alertType === 'success',
    }">
    @if (title()) {
        <h3
            class="mb-0 mt-1.5"
            [ngClass]="{
                'text-redesign-danger-600 dark:text-redesign-danger-500': alertType === 'danger',
                'text-redesign-warning-500': alertType === 'warning',
                'text-redesign-info-500 dark:text-white': alertType === 'info',
                'text-redesign-success-600 dark:text-redesign-success-400': alertType === 'success',
            }">

            @let icon = iconMap[alertType];
            @if (icon) {
                <big-icon
                    [icon]="icon"
                    [size]="'w-8'"
                    [inline]="true"
                    class="mr-1.5 fill-current shrink-0 -translate-y-1 align-top" />
                <span>{{ title() }}</span>
            }
        </h3>
    }
    <ng-content />
</div>
